import type {Conversation} from "@repo/guide-types";

export function getHasStudentMessages(conversation: Conversation): boolean {
    return conversation.some(
        (message) => message.user === "Student" && !message.uiOnly,
    );
}
